import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = ({ isScrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`fixed w-full transition-all duration-300 z-50 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img src="/images/senti-green-logo.png" alt="Senti Logo" className="h-10" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8">
          <Link to="/technology" className="text-primary hover:text-secondary font-medium">Technology</Link>
          <Link to="/applications" className="text-primary hover:text-secondary font-medium">Applications</Link>
          <Link to="/partners" className="text-primary hover:text-secondary font-medium">Partners</Link>
          <Link to="/contact" className="text-primary hover:text-secondary font-medium">Contact</Link>
        </div>
        
        <Link to="/investors" className="hidden md:block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-secondary transition-colors">
          For Investors
        </Link>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden flex items-center" 
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {mobileMenuOpen ? (
            <X className="h-6 w-6 text-primary" />
          ) : (
            <Menu className="h-6 w-6 text-primary" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg py-4">
          <div className="container mx-auto px-6 flex flex-col space-y-4">
            <Link to="/technology" className="text-primary hover:text-secondary font-medium py-2" onClick={() => setMobileMenuOpen(false)}>Technology</Link>
            <Link to="/applications" className="text-primary hover:text-secondary font-medium py-2" onClick={() => setMobileMenuOpen(false)}>Applications</Link>
            <Link to="/partners" className="text-primary hover:text-secondary font-medium py-2" onClick={() => setMobileMenuOpen(false)}>Partners</Link>
            <Link to="/contact" className="text-primary hover:text-secondary font-medium py-2" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            <Link to="/investors" className="bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-secondary transition-colors inline-block text-center" onClick={() => setMobileMenuOpen(false)}>
              For Investors
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
